import React from "react";

import AdminBreadcrumbs from "Components/Shared/BreadCrumbs";
import { Box, Grid } from "@mui/material";
import { PUCAdminBox } from "Helpers/overrides";
import NotificationBreadCrumb from "Components/Shared/NotificationBreadCrumb";

const BodyWrapper = ({ children }) => {

  return (
    <Grid rowSpacing={2}>
      {!window.location.pathname.includes("notification") ?
        <AdminBreadcrumbs /> :
        <NotificationBreadCrumb />
      }
      {!window.location.pathname.includes("/admin/all-request/view/")?<PUCAdminBox>
        <>{children}</>
      </PUCAdminBox>:<Box>
      <>{children}</>
      </Box>}
    </Grid>
  );
};

export default BodyWrapper;
